import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';

export interface BypassData {
  changes: number;
}

@Component({
  selector: 'app-bypass',
  templateUrl: './bypass.component.html',
  styleUrls: ['./bypass.component.css'],
})
export class BypassComponent implements OnInit {

  title = 'Añada un comentario';
  description = 'El bypass permite modificar manualmente los valores de salida del sistema';
  placeholder = 'Cambiada la característica "X" porque...';
  comments: string;
  characteristics: CharacteristicsObject;

  constructor(public dialogRef: MatDialogRef<BypassComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CharacteristicsObject) {
  }

  ngOnInit() {
    this.characteristics = this.data;
    this.comments = '';
  }

  public commentsEvent($event) {
    this.comments = $event;
  }
}
